export const BRAND_NAME = "MΛY SΞCRΞT";
